export class IddleState {
	public stateController;
	public stateObject;
	public rouletteController;
	public menuButton;
	public rulesButton;
	public spinButton;
	public undoButton;
	public deleteButton;
	public infoButton;

	constructor(scene, stateController) {
		this.stateController = stateController;
		this.stateObject = scene;
		this.rouletteController = scene.rouletteController;
	}

	enterFrom(oldState) {
		console.log(this.toString() + ' - enter from: ' + (oldState === null ? 'null' : oldState.toString()));
		this.rouletteController.setControlActivity(true);
	}

	exitTo(newState) {
		console.log(this.toString() + ' - Exit To: ' + newState.toString());
	}

	toString() {
		return 'IddleState';
	}
}
